const defaultImagePath = "/mockup-hero.png";

const getAbsoluteUrl = (path = "/") => {
  if (typeof window === "undefined") {
    return path;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}`;
};

const findOrCreateMeta = (selector, attributes) => {
  let node = document.head.querySelector(selector);

  if (!node) {
    node = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      node.setAttribute(key, value);
    });
    document.head.appendChild(node);
  }

  return node;
};

const setNamedMeta = (name, content) => {
  const node = findOrCreateMeta(`meta[name="${name}"]`, { name });
  node.setAttribute("content", content);
};

const setPropertyMeta = (property, content) => {
  const node = findOrCreateMeta(`meta[property="${property}"]`, { property });
  node.setAttribute("content", content);
};

const setCanonical = (href) => {
  let node = document.head.querySelector('link[rel="canonical"]');

  if (!node) {
    node = document.createElement("link");
    node.rel = "canonical";
    document.head.appendChild(node);
  }

  node.href = href;
};

export const setPageSeo = ({
  title,
  description,
  path = "/",
  robots = "index,follow",
  imagePath = defaultImagePath,
  type = "website",
}) => {
  if (typeof document === "undefined") {
    return;
  }

  const canonicalUrl = getAbsoluteUrl(path);
  const imageUrl = getAbsoluteUrl(imagePath);

  document.title = title;
  setCanonical(canonicalUrl);

  setNamedMeta("description", description);
  setNamedMeta("robots", robots);
  setNamedMeta("googlebot", robots);
  setNamedMeta("twitter:card", "summary_large_image");
  setNamedMeta("twitter:title", title);
  setNamedMeta("twitter:description", description);
  setNamedMeta("twitter:image", imageUrl);

  setPropertyMeta("og:locale", "it_IT");
  setPropertyMeta("og:type", type);
  setPropertyMeta("og:title", title);
  setPropertyMeta("og:description", description);
  setPropertyMeta("og:url", canonicalUrl);
  setPropertyMeta("og:image", imageUrl);
  setPropertyMeta("og:image:alt", "Anteprima Cards, biglietto da visita digitale");
};

export const homeSeo = {
  title: "Cards | Biglietto da visita digitale per la filiera funebre",
  description:
    "Crea e gestisci una Cards: il biglietto da visita digitale per imprese funebri, fornitori e professionisti della filiera.",
  path: "/",
  imagePath: "/mockup-hero.png",
  robots: "index,follow",
};

export const manageSeo = {
  title: "Gestisci la tua Cards | Area personale",
  description:
    "Accedi all'area personale Cards per aggiornare dati, contatti, azienda, QR code e informazioni visibili nel biglietto da visita digitale.",
  path: "/gestisci",
  imagePath: "/mockup-hero.png",
  robots: "noindex,nofollow,noarchive",
};

export const termsSeo = {
  title: "Termini e condizioni OFC Cards",
  description:
    "Termini e condizioni di utilizzo del servizio OFC Cards fornito da OFC S.R.L.",
  path: "/termini-e-condizioni",
  imagePath: "/cards-logo-primary.svg",
  robots: "noindex,nofollow,noarchive",
};

export const privacySeo = {
  title: "Privacy Policy OFC Cards",
  description:
    "Informativa sul trattamento dei dati personali del servizio OFC Cards fornito da OFC S.R.L.",
  path: "/privacy-policy",
  imagePath: "/cards-logo-primary.svg",
  robots: "noindex,nofollow,noarchive",
};

export const noIndexSeo = {
  title: "Cards | Biglietto da visita digitale",
  description: "Cards, biglietto da visita digitale.",
  path: "/",
  imagePath: "/cards-logo-primary.svg",
  robots: "noindex,nofollow,noarchive",
};

export const privateAreaSeo = {
  title: "Area personale Cards",
  description: "Area riservata per gestire una Cards.",
  path: "/gestisci",
  imagePath: "/cards-logo-primary.svg",
  robots: "noindex,nofollow,noarchive",
};

export const cardNoIndexSeo = {
  title: "Cards | Biglietto da visita digitale",
  description: "Biglietto da visita digitale Cards.",
  imagePath: "/cards-logo-primary.svg",
  robots: "noindex,nofollow,noarchive",
};
